<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        title="Who am I?"
      >
      I’m a seasoned Full Stack Developer and technology enthusiast from Colombia, with deep expertise in the MERN stack (MongoDB, Express, React, Node.js) and a strong background in leading development teams. My passion for coding drives my ability to quickly master new technologies, allowing me to rapidly adapt to emerging frameworks and tools by diving into documentation and applying them effectively. As a technical lead, I focus on aligning development efforts with business objectives, ensuring the delivery of scalable, high-quality solutions. My short learning curve enables me to continuously innovate and drive efficiency in complex web projects.  
    </content-section>
      <!-- <content-section
        v-if="prouds"
        title="What am I proud of?"
      >
        <v-layout
          v-for="(proud, i) in prouds"
          :key="i"
        >
          <v-flex
            md1
            xs3
          >
            <v-icon right>
              {{ proud.icon }}
            </v-icon>
          </v-flex>
          <v-flex
            md11
            xs9
          >
            <p>
              <strong>{{ proud.text }}</strong><br>
              <small>{{ proud.source }}</small>
            </p>
          </v-flex>
        </v-layout>
      </content-section> -->
      <content-section
        v-if="skills"
        id="to-timeline"
        title="Skills"
      >
        <v-layout wrap>
          <template
            v-for="(skill, i) in skills"
          >
            <v-flex
              v-if="skill.divider"
              :key="i"
              md12
              xs12
              mb-4
            />
            <v-flex
              v-else
              :key="i"
              md6
              xs12
            >
              <div
                class="mr-2 ml-2"
              >
                <div class="align-center">
                  <v-icon
                    small
                  >
                    {{ skill.icon }}
                  </v-icon>
                  {{ skill.title }}
                </div>
                <v-progress-linear
                  class="progress"
                  color="secondary"
                  height="3"
                  :value="skill.value"
                />
              </div>
            </v-flex>
          </template>
        </v-layout>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'MainContent',
  components: { ContentSection },
  data      : () => ({
    prouds: [
      {
        icon  : 'mdi-help',
        text  : 'my family',
        source: '',
      },
    ],
    educations: [
      {
        from       : '2015',
        to         : '2019 (not finished yet)',
        title      : 'Bachelor\'s degree, Information Technology',
        location   : 'Seraj University',
        description: 'Became a member of University Academic Association of Computer Science',
      },
    ],
    skills: [
      {
        title: 'AWS',
        icon : 'mdi-aws',
        value: 80,
      },
      {
        title: 'Google Cloud',
        icon : 'mdi-google',
        value: 85,
      },
      { divider: true },
      {
        title: 'SCRUM',
        icon : 'mdi-rocket',
        value: 85,
      },
      {
        title: 'KANBAN',
        icon : 'mdi-rocket',
        value: 65,
      },
      { divider: true },
      {
        title: 'Quasar',
        icon : 'mdi-cellphone',
        value: 95,
      },
      {
        title: 'Ionic',
        icon : 'mdi-cellphone',
        value: 85,
      },
      {
        title: 'React-Native',
        icon : 'mdi-cellphone',
        value: 70,
      },
      {
        title: 'Meteor',
        icon : 'mdi-cellphone',
        value: 80,
      },
      {
        title: 'Objetive-C',
        icon : 'mdi-cellphone',
        value: 55,
      },
      {
        title: 'Swift',
        icon : 'mdi-cellphone',
        value: 45,
      },
      { divider: true },
      {
        title: 'NodeJS',
        icon : 'mdi-nodejs',
        value: 95,
      },
      {
        title: 'Python',
        icon : 'mdi-language-python',
        value: 82,
      },
      {
        title: 'PHP',
        icon : 'mdi-language-php',
        value: 95,
      },
      {
        title: 'Go Lang',
        icon : 'mdi-language-go',
        value: 60,
      },
      { divider: true },
      {
        title: 'Vue.js Framework',
        icon : 'mdi-vuejs',
        value: 97,
      },
      {
        title: 'Angular',
        icon : 'mdi-angular',
        value: 82,
      },
      {
        title: 'React',
        icon : 'mdi-react',
        value: 71,
      },

      {
        title: 'TypeScript',
        icon : 'mdi-language-typescript',
        value: 82,
      },
      {
        title: 'FrontEnd: html5, css3, sass, less',
        icon : 'mdi-web',
        value: 95,
      },
      {
        title: 'Quasar - Vuetify - Nuxtjs - Nextjs',
        icon : 'mdi-web',
        value: 95,
      },
      {
        title: 'CMS: WordPress, PrestaShop, Drupal',
        icon : 'mdi-web',
        value: 95,
      },
      { divider: true },
      {
        title: 'MongoDB',
        icon : 'mdi-database',
        value: 90,
      },
      {
        title: 'MySQL',
        icon : 'mdi-database',
        value: 90,
      },
      {
        title: 'PostgreSQL',
        icon : 'mdi-database',
        value: 70,
      },
      {
        title: 'noSQL',
        icon : 'mdi-database',
        value: 90,
      },
      {
        title: 'SQL Server',
        icon : 'mdi-database',
        value: 69,
      },
      { divider: true },
      {
        title: 'Ubuntu Server',
        icon : 'mdi-ubuntu',
        value: 70,
      },
      {
        title: 'CentOS Server',
        icon : 'mdi-linux',
        value: 80,
      },
      {
        title: 'Ethical Hacker: CSRF, SSRF, XSS, RCE, OWASP',
        icon : 'mdi-shield-lock',
        value: 90,
      },
      {
        title: 'Git',
        icon : 'mdi-git',
        value: 87,
      },
      { divider: true },
    ],
  }),
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.progress {
  margin-top: 0.1rem;
}
</style>
